import { Program, UserState } from 'models/user';
import React, { useCallback } from 'react';
import styled from 'styled-components/macro';
import Group from './Group';
import Item from './Item';

const MenuContainer = styled.div<{ isMenuOpen: boolean }>`
  width: 100%;
  padding: 10px 6px 0 6px;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
`;

interface MenuContentProps {
  elements: UserState['menuPrograms'];
  isMenuOpen: boolean;
}

const MenuContent: React.FC<MenuContentProps> = ({ elements, isMenuOpen }) => {
  const renderMenu = useCallback(
    (items: UserState['menuPrograms'], deep: number) => {
      if (items) {
        return items.map((elm: Program, i: number) => {
          const id = `${elm}-${i}`;
          if (elm.children.length) {
            return (
              <Group name={elm.programName} key={id}>
                {renderMenu(elm.children, deep + 1)}
              </Group>
            );
          }
          return (
            <Item
              name={elm.programName}
              id={elm.idProgram}
              key={id}
              isFirst={false}
              isMenuOpen={isMenuOpen}
            />
          );
        });
      }
    },
    [isMenuOpen],
  );

  return <MenuContainer isMenuOpen={isMenuOpen}>{renderMenu(elements, 0)}</MenuContainer>;
};

export default MenuContent;
